// extracted by mini-css-extract-plugin
export var calendarView = "_qr-0";
export var dayButton = "_qr-1";
export var dayCircle = "_qr-2";